import moment from "moment";
import React, { useEffect, useState } from "react";
import { Alert, Table } from "react-bootstrap";
import { defineMessages, useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";

import TableFooter from "../../../../components/TableFooter.jsx";
import genericTranslations from "../../../../utils/genericTranslations.js";
import {
  selectMalfunctionsCategories,
  isLoadingMalfunctionsCategories,
} from "../../selectors";
import { fetchMalfunctionsCategories } from "../../thunks.js";

const messages = defineMessages({
  errorMessage: {
    id: "modules.VehicleStatus.components.VehicleStatuses.errorMessage",
    description: "Error message fetching vehicle statuses",
    defaultMessage: "Something went wrong!",
  },
  closeNotification: {
    id: "modules.VehicleStatus.components.VehicleStatuses.closeNotification",
    description: "Button close notification",
    defaultMessage: "Close notification",
  },
  loading: {
    id: "modules.VehicleStatus.components.VehicleStatuses.loading",
    description: "Loading message",
    defaultMessage: "Loading, please wait!",
  },
  code: {
    id: "modules.Malfunctions.components.CategoriesList.code",
    description: "Code",
    defaultMessage: "Code",
  },
  description: {
    id: "modules.Malfunctions.components.CategoriesList.description",
    description: "Description",
    defaultMessage: "Description",
  },
  vehicle: {
    id: "modules.Malfunctions.components.CategoriesList.vehicle",
    description: "Vehicle Type",
    defaultMessage: "Vehicle-type",
  },
  createdAt: {
    id: "modules.Malfunctions.components.CategoriesList.createdAt",
    description: "Malfunctions created at",
    defaultMessage: "Created at",
  },
  updatedAt: {
    id: "modules.Malfunctions.components.CategoriesList.updatedAt",
    description: "Malfunctions updated at",
    defaultMessage: "Updated at",
  },
});

const CategoriesList = () => {
  const intl = useIntl();
  const dispatch = useDispatch();

  const [error, setError] = useState(undefined);

  const isLoading = useSelector(isLoadingMalfunctionsCategories);
  const categories = useSelector(selectMalfunctionsCategories);

  useEffect(() => {
    const fetchData = async () => {
      try {
        await dispatch(fetchMalfunctionsCategories());
      } catch (err) {
        setError(err);
      }
    };

    fetchData();
  }, [dispatch]);

  const mapCategoryToTableRow = (cat) => (
    <tr key={`malfunction-${cat.id}`}>
      <td>
        <Link to={`/malfunctions/categories/edit/${cat.id}`}>{cat.value}</Link>
      </td>
      <td>{cat.label}</td>
      <td>{cat.vehicleType}</td>
      <td>{moment(cat.createdAt).format("DD MMM YYYY")}</td>
      <td>{moment(cat.updatedAt).format("DD MMM YYYY")}</td>
    </tr>
  );

  const dismissError = () => setError(null);

  return (
    <div>
      {error && (
        <Alert variant="danger" onClose={dismissError} dismissible>
          <Alert.Heading>
            {intl.formatMessage(genericTranslations.errorMessage)}
          </Alert.Heading>
          <p>{error.toString()}</p>
        </Alert>
      )}

      {isLoading && (
        <span className="align-middle">
          {intl.formatMessage(genericTranslations.loadingInProgress)}
        </span>
      )}

      {!isLoading && categories.length === 0 && (
        <span className="align-middle">
          {intl.formatMessage(genericTranslations.nothingFound)}
        </span>
      )}

      {!isLoading && categories && categories.length > 0 && (
        <Table responsive>
          <thead>
            <tr>
              <td>{intl.formatMessage(messages.code)}</td>
              <td>{intl.formatMessage(messages.description)}</td>
              <td>{intl.formatMessage(messages.vehicle)}</td>
              <td>{intl.formatMessage(messages.createdAt)}</td>
              <td>{intl.formatMessage(messages.updatedAt)}</td>
            </tr>
          </thead>
          <tbody>{categories.map((cat) => mapCategoryToTableRow(cat))}</tbody>
        </Table>
      )}

      <TableFooter actionPath="/malfunctions/categories/add" />
    </div>
  );
};

export default CategoriesList;
